import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import type React from 'react'

import { StyledListItem } from './styles'

interface SortableListItemProps {
  children: React.ReactNode
  id: string
}

export function SortableListItem({ children, id }: SortableListItemProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <StyledListItem
      $dragging={isDragging}
      data-testid="draggable-row"
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
    >
      {children}
    </StyledListItem>
  )
}
